export { renderTagPickerInput_unstable as renderTagPickerInput } from '@fluentui/react-tag-picker';
